import { getBubbleContent } from "./data/API";
 
// Standalone utility function to fetch bubble content
const fetchBubbleContent = async (title, setBubbleContents) => {
    try {
        console.log(title, "-----");
        const response = await getBubbleContent(title);
        
        if (response.data && response.data.content) {
            setBubbleContents(prev => ({
                ...prev,
                [title]: response.data.content
            }));
        } else {
            console.log("No content found in response data:", response.data);
            setBubbleContents(prev => ({
                ...prev,
                [title]: 'Content not available'
            }));
        }
    } catch (error) {
        console.error(`Error fetching bubble content for ${title}:`, error);
        setBubbleContents(prev => ({
            ...prev,
            [title]: 'Failed to load content'
        }));
    }
};

export default fetchBubbleContent;